import React from 'react';

const iconProtectionPlan = props => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="24"
        cy="24"
        r="24"
        fill={props?.circleFill ? props.circleFill : '#F2F8F9'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8926 16.75V25C15.8926 28.2302 19.1729 30.569 22.3816 32.8567C22.6827 33.0713 22.9831 33.2856 23.2802 33.5C23.5772 33.2856 23.8776 33.0713 24.1787 32.8567C27.3874 30.569 30.6677 28.2302 30.6677 25V16.75L23.2802 14L15.8926 16.75ZM26.7735 20L21.8403 25.2776L19.7243 23.3044L18.8476 24.2434L21.8797 27.125L27.7127 20.8874L26.7735 20Z"
        fill={props && props.fill ? props.fill : '#016A78'}
      />
    </svg>
  );

export default iconProtectionPlan;
